module.exports = __webpack_public_path__ + "img/login-pusuqui.0d579460.svg";